import { COLORS } from '@bcm/constants';
import { StyleSheet } from 'react-native';
import { ICON_TYPES } from './iconTypes';

const styles = StyleSheet.create({
	rotate90: {
		transform: [{ rotate: '90deg' }]
	}
});

export default {
	burnSuperficial: {
		name: 'signal-cellular-1',
		type: ICON_TYPES.materialCommunityIcons,
		style: {
			...styles.rotate90,
			color: COLORS.severity.one,
		},
		text: 'Superficial',
	},
	burnPartialThickness: {
		name: 'signal-cellular-2',
		type: ICON_TYPES.materialCommunityIcons,
		style: {
			...styles.rotate90,
			color: COLORS.severity.two,
		},
		text: 'Partial Thickness',
	},
	burnDeepPartialThickness: {
		name: 'signal-cellular-2',
		type: ICON_TYPES.materialCommunityIcons,
		style: {
			...styles.rotate90,
			color: COLORS.severity.three,
		},
		text: 'Deep Partial Thickness',
	},
	burnFullThickness: {
		name: 'signal-cellular-3',
		type: ICON_TYPES.materialCommunityIcons,
		style: {
			...styles.rotate90,
			color: COLORS.severity.four,
		},
		text: 'Full Thickness',
	},
};